import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "blocked-container"
};
const _hoisted_2 = ["innerHTML"];
const _hoisted_3 = {
  class: "blocked-content"
};
const _hoisted_4 = {
  class: "back-button-wrapper"
};
const _hoisted_5 = {
  class: "status-animation"
};
const _hoisted_6 = {
  class: "status-icon"
};
const _hoisted_7 = {
  class: "status-badge"
};
const _hoisted_8 = {
  class: "status-info"
};
const _hoisted_9 = {
  class: "status-actions"
};
const _hoisted_10 = {
  class: "help-info"
};
const _hoisted_11 = {
  class: "quick-links"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon");
  const _component_el_button = _resolveComponent("el-button");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
    class: "background-wrapper",
    innerHTML: _ctx.backgroundImagesTemplate
  }, null, 8, _hoisted_2), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_el_button, {
    class: "back-button",
    onClick: $options.goHome,
    circle: "",
    size: "large"
  }, {
    default: _withCtx(() => [_createVNode(_component_font_awesome_icon, {
      icon: "home"
    })]),
    _: 1
  }, 8, ["onClick"])]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createVNode(_component_font_awesome_icon, {
    icon: "ban",
    class: "ban-icon"
  }), _createElementVNode("div", _hoisted_7, [_createVNode(_component_font_awesome_icon, {
    icon: "exclamation",
    class: "exclamation-icon"
  })])])]), _createElementVNode("div", _hoisted_8, [_cache[9] || (_cache[9] = _createElementVNode("h1", {
    class: "status-title"
  }, "图片访问被禁止", -1)), _cache[10] || (_cache[10] = _createElementVNode("p", {
    class: "status-description"
  }, " 抱歉，当前图片已被禁止访问。 ", -1)), _cache[11] || (_cache[11] = _createElementVNode("p", {
    class: "status-description-en"
  }, " Sorry, current image is prohibited from being accessed. ", -1)), _createElementVNode("div", _hoisted_9, [_createVNode(_component_el_button, {
    type: "primary",
    size: "large",
    class: "action-btn primary-btn",
    onClick: $options.goHome
  }, {
    default: _withCtx(() => [_createVNode(_component_font_awesome_icon, {
      icon: "home",
      class: "btn-icon"
    }), _cache[3] || (_cache[3] = _createTextVNode(" 返回首页 ", -1))]),
    _: 1
  }, 8, ["onClick"]), _createVNode(_component_el_button, {
    size: "large",
    class: "action-btn secondary-btn",
    onClick: $options.goBack
  }, {
    default: _withCtx(() => [_createVNode(_component_font_awesome_icon, {
      icon: "arrow-left",
      class: "btn-icon"
    }), _cache[4] || (_cache[4] = _createTextVNode(" 返回上页 ", -1))]),
    _: 1
  }, 8, ["onClick"])]), _createElementVNode("div", _hoisted_10, [_cache[8] || (_cache[8] = _createElementVNode("p", {
    class: "help-text"
  }, "您可以尝试：", -1)), _createElementVNode("div", _hoisted_11, [_createElementVNode("a", {
    href: "javascript:void(0)",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.goHome && $options.goHome(...args)),
    class: "quick-link"
  }, [_createVNode(_component_font_awesome_icon, {
    icon: "cloud-upload-alt"
  }), _cache[5] || (_cache[5] = _createTextVNode(" 图片上传 ", -1))]), _createElementVNode("a", {
    href: "javascript:void(0)",
    onClick: _cache[1] || (_cache[1] = (...args) => $options.refreshPage && $options.refreshPage(...args)),
    class: "quick-link"
  }, [_createVNode(_component_font_awesome_icon, {
    icon: "redo"
  }), _cache[6] || (_cache[6] = _createTextVNode(" 刷新页面 ", -1))]), _createElementVNode("a", {
    href: "javascript:void(0)",
    onClick: _cache[2] || (_cache[2] = (...args) => $options.contactSupport && $options.contactSupport(...args)),
    class: "quick-link"
  }, [_createVNode(_component_font_awesome_icon, {
    icon: "question-circle"
  }), _cache[7] || (_cache[7] = _createTextVNode(" 联系支持 ", -1))])])]), _cache[12] || (_cache[12] = _createElementVNode("div", {
    class: "powered-by"
  }, [_createElementVNode("p", null, [_createTextVNode("Powered By: "), _createElementVNode("a", {
    href: "https://github.com/MarSeventh/CloudFlare-ImgBed",
    class: "project-link"
  }, " CloudFlare-ImgBed ")])], -1))])]), _cache[13] || (_cache[13] = _createStaticVNode("<div class=\"floating-elements\" data-v-76cc7d3a><div class=\"floating-shape shape-1\" data-v-76cc7d3a></div><div class=\"floating-shape shape-2\" data-v-76cc7d3a></div><div class=\"floating-shape shape-3\" data-v-76cc7d3a></div><div class=\"floating-shape shape-4\" data-v-76cc7d3a></div><div class=\"floating-shape shape-5\" data-v-76cc7d3a></div></div>", 1))]);
}